<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="mb-3" [ngClass]="displayLinksSection ? 'col-12 col-sm-6 col-md-3' : 'col-12 col-sm-6 col-md-4'">
                <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_DATA_MAINTENANCE_TITLE"></h4>
                <div>
                    <button class="btn btn-link" (click)="openNotificationMaintenanceLocation()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MAINTENANCE_LOCATION"></span>
                    </button>
                </div>

                <div>
                    <button class="btn btn-link" (click)="openNotificationMaintenanceSysConfig()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MAINTENANCE_SYSTEM_CONFIG"></span>
                    </button>
                </div>
            </div>
            <div class="mb-3" [ngClass]="displayLinksSection ? 'col-12 col-sm-6 col-md-3' : 'col-12 col-sm-6 col-md-4'">
                <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></h4>
                <div>
                    <button class="btn btn-link" (click)="openEquipmentHistory()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_HISTORY"></span>
                    </button>
                </div>
                <div>
                    <button class="btn btn-link" (click)="openEquipmentConfig()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_SUB_EQUIPMENT"></span>
                    </button>
                </div>
                @if (displayOtherTasks) {
                    <div>
                        <button class="btn btn-link" (click)="openEquipmentOtherTasks()">
                            <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_OTHER_TASKS"></span>
                        </button>
                    </div>
                }
            </div>
            @if (!notification.isApplicationSpecialist) {
                <div
                    class="mb-3"
                    [ngClass]="
                        displayLinksInMultiColumns
                            ? 'col-12 col-sm-6 col-md-2'
                            : displayLinksSection
                              ? 'col-12 col-sm-6 col-md-3'
                              : 'col-12 col-sm-6 col-md-4'
                    "
                >
                    <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_TITLE"></h4>
                    <div>
                        <button
                            class="btn btn-link"
                            (click)="openNotificationMaterialRequest()"
                            [disabled]="isMaterialRequested()"
                        >
                            <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_REQUEST"></span>
                        </button>
                    </div>
                    @if (displayMaterialQuote) {
                        <div>
                            <button class="btn btn-link" (click)="openNotificationSalesQuote()">
                                <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_QUOTE"></span>
                            </button>
                        </div>
                    }
                    @if (displayMaterialPricing) {
                        <div>
                            <button class="btn btn-link" (click)="openNotificationMaterialPricing()">
                                <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_PRICING"></span>
                            </button>
                        </div>
                    }
                </div>
            }
            @if (displayLinksSection) {
                <div [ngClass]="displayLinksInMultiColumns ? 'col-12 col-sm-6 col-md-4' : 'col-12 col-sm-6 col-md-3'">
                    <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_LINKS_TITLE"></h4>
                    <div class="links">
                        <div class="link-container">
                            @if (teamPlayFleetLinkForNotification.length > 0) {
                                <div paceCoreLink>
                                    <a
                                        href="{{ teamPlayFleetLinkForNotification }}"
                                        class="pace-link btn btn-link"
                                        target="_blank"
                                    >
                                        <span>teamplay Fleet</span>
                                    </a>
                                </div>
                            }
                            @if (serviceSoftwareOnlineLinkForNotification.length > 0) {
                                <div paceCoreLink>
                                    <a
                                        href="{{ serviceSoftwareOnlineLinkForNotification }}"
                                        class="pace-link btn btn-link"
                                        target="_blank"
                                    >
                                        <span>SeSO</span>
                                    </a>
                                </div>
                            }
                            @if (displayDocBox) {
                                <div>
                                    <button class="btn btn-link" (click)="callDocBoxPage()">
                                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_DOC_BOX"></span>
                                    </button>
                                </div>
                            }
                            @if (byBoxKonnectLink.length > 0) {
                                <div paceCoreLink>
                                    <a href="{{ byBoxKonnectLink }}" class="pace-link btn btn-link" target="_blank">
                                        <span>ByBox Konnect</span>
                                    </a>
                                </div>
                            }
                            @if (cbDocOnlineLink.length > 0) {
                                <div paceCoreLink>
                                    <a href="{{ cbDocOnlineLink }}" class="pace-link btn btn-link" target="_blank">
                                        <span>CB-Doc</span>
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
